import { GenericChoiceStep } from '@eneco/flows/components';
import { FlowActions, FlowRoute, FlowRouteCategory } from '@eneco/flows/types';

import { FlowContextServiceGemak } from './context';
import { AddressStep } from './steps/AddressStep/AddressStep';
import { BoilerBrandStep } from './steps/BoilerBrandStep/BoilerBrandStep';
import { ContactDetailsStep } from './steps/ContactDetailsStep/ContactDetailsStep';
import { ServiceGemakOfferStep } from './steps/OfferStep/OfferStep';
import { PersonalDetailsStep } from './steps/PersonalDetailsStep/PersonalDetailsStep';
import { ReachabilityStep } from './steps/ReachabilityStep/ReachabilityStep';
import { SummaryStep } from './steps/SummaryStep/SummaryStep';

export const initialContext: FlowContextServiceGemak = {
  hasFinishedBoilerCheck: false,
  voucherCode: 'Default-SG',
  offerType: 'serviceGemak',
};

export const routes: FlowRoute<FlowContextServiceGemak>[] = [
  {
    id: 'ADDRESS',
    path: '/adres/',
    category: FlowRouteCategory.BoilerCheck,
    component: AddressStep,
  },
  {
    id: 'BOILERCHECKOWNER',
    path: '/ketelcheck/eigendom/',
    category: FlowRouteCategory.BoilerCheck,
    component: GenericChoiceStep,
  },
  {
    id: 'BOILERCHECKBRAND',
    path: '/ketelcheck/merk/',
    category: FlowRouteCategory.BoilerCheck,
    component: BoilerBrandStep,
  },
  {
    id: 'BOILERCHECKREACHABILITY',
    path: '/ketelcheck/bereikbaarheid/',
    category: FlowRouteCategory.BoilerCheck,
    component: ReachabilityStep,
  },
  {
    id: 'BOILERCHECKASBESTOS',
    path: '/ketelcheck/asbest/',
    category: FlowRouteCategory.BoilerCheck,
    component: GenericChoiceStep,
  },
  {
    id: 'OFFER',
    path: '/je-aanbod/',
    category: FlowRouteCategory.Offer,
    component: ServiceGemakOfferStep,
  },
  {
    id: 'PERSONAL_DETAILS',
    path: '/je-gegevens/persoonlijke-gegevens/',
    category: FlowRouteCategory.Details,
    component: PersonalDetailsStep,
  },
  {
    id: 'CONTACT_DETAILS',
    path: '/je-gegevens/contactgegevens/',
    category: FlowRouteCategory.Details,
    component: ContactDetailsStep,
  },
  {
    id: 'SUMMARY',
    path: '/je-gegevens/controle-keuze/',
    category: FlowRouteCategory.Summary,
    component: SummaryStep,
  },
];
export const actions: FlowActions<FlowContextServiceGemak> = {};
